// extracted by mini-css-extract-plugin
module.exports = {"description":"ComicInfoForm_description_33rZs","radioCaption":"ComicInfoForm_radioCaption_3CKfK","headingText":"ComicInfoForm_headingText_80Hew"};